module.exports = __webpack_public_path__ + "static/media/test.29dd79a6.glb";